import { h, render, Component } from 'preact';
import { classNames, formatNumber } from '../utils/utils';
import TxrPurchaseAccountForm from './txr-purchase-account-form';
import TxrPurchaseForm from './txr-purchase-form';
import { PlanService } from '../plan-service.service';
import { v4 as uuidv4 } from 'uuid';
import { appConfig } from '../app.config';
import confetti from 'canvas-confetti';

class TxrPurchaseWorkflow extends Component {
    state = {
        step: 0,
        plan: 'starter',
        prepurchaseId: undefined,
        step1filled: false,
        step2filled: false,
        accountInfo: undefined,
        refresh: {},
        planDescription: {
            includedFeatures: [],
            optionalFeatures: []
        },
        features: [],
        isHipaa: false,
        activeFeatures: [],
        selectedFeatures: {},
        isPurchased: false,
        tokenData: undefined,
        hipaa: {}
    }

    componentDidMount() {
        this.state.selectedFeatures = {};
        this.planService = new PlanService();
        this.state.hipaa = this.planService.getHipaaDescription();
        window.onpopstate = (e) => {
            this.restoreState();
        }
        this.restoreState();
    }
    setStep = (step) => {
        this.setState({ step: step });
        if(step === 0) {
            this.setState({ step1filled: false });
        }
        this.scrollTop();
    }

    completeStep1 = (accountInfo) => {
        this.state.accountInfo = accountInfo;
        this.setState({ step: 1, step1filled: true, accountInfo: accountInfo });
        this.scrollTop();
        const params = { plan: this.state.plan, step: 1, features: this.getFeatures(), prepurchaseId: this.state.prepurchaseId, isHipaa: this.state.isHipaa };
        this.saveHistoryState(params);
    }
    enableHipaa = () => {
        this.setState({ isHipaa: true });
    }
    disableHipaa = () => {
        this.setState({ isHipaa: false });
    }

    completeStep1Go11= () => {
        this.setState({ step: 11 });
        const params = { plan: this.state.plan, step: 11, features: this.getFeatures(), prepurchaseId: this.state.prepurchaseId, isHipaa: this.state.isHipaa };
        this.saveHistoryState(params);
    }
    completeStep2 = (skip) => {
        this.state.step = 2;
        if (skip) {
            this.skipFeatures();
        } else {
            this.addFeatures();
        }
        this.setState({ step: 2, step2filled: true });
        this.scrollTop();

    }

    completeStep3(tokenData) {
        localStorage.setItem(appConfig.prepurchaseAccountInfoId, undefined);
        this.state.tokenData = tokenData;
        this.setState({ isPurchased: true });
        this.onConfetti();   
    }

    goToSmsHosting() {
        window.location.href=`${appConfig.appUrl}/app/login?username=${encodeURIComponent(this.state.tokenData.username)}`;
        /*
        window.location.href=
        `${appConfig.appUrl}/app/sms-hosting?purchase=${this.state.plan}&access_token=${encodeURIComponent(this.state.tokenData.access_token)}`+
        `&refresh_token=${encodeURIComponent(this.state.tokenData.refresh_token)}&refresh_token_expires_in=${this.state.tokenData.refresh_token_expires_in}&expires_in=${this.state.tokenData.expires_in}&username=${encodeURIComponent(this.state.tokenData.username)}`;
        */
        /*
       window.location.href=
        `http://localhost:3000/app/sms-hosting?purchase=${this.plan}&access_token=${encodeURIComponent(this.tokenData.access_token)}`+
        `&refresh_token=${encodeURIComponent(this.tokenData.refresh_token)}&refresh_token_expires_in=${this.tokenData.refresh_token_expires_in}&expires_in=${this.tokenData.expires_in}&username=${encodeURIComponent(this.username)}`;
        */
      
    }

    getFeatures = () => {
        let res = this.getFeaturesArray();
        return res.join(',');
    }
    getFeaturesDescArray = () => {
        let res = [];
        this.state.features.forEach((f) => {
            if (f.isChecked) {
                res.push(f.name);
            }
        });
        return res.join(',');
    }

    getPlanText = () => {
        let res = 'The ' + this.state.planDescription.name + ' Plan';
        if (this.state.activeFeatures.length > 0) {
            res = res + ' and ';
        }
        res = res + this.state.activeFeatures.map((f) => f.name).join(', ');
        return res;
    }

    scrollTop() {
        window.scroll({
            top: 0, 
            left: 0, 
            behavior: 'smooth'
        });
    }

    restoreState = () => {
        const index = window.location.href.indexOf('?');
        this.url = window.location.href.substring(0, index);
        var hashes = window.location.href.slice(index + 1).split('&');

        for (var i = 0; i < hashes.length; i++) {
            let hash = hashes[i].split('=');
            if (hash[0] === 'plan') {
                this.state.plan = hash[1].toLowerCase();
            }
            if (hash[0] === 'step') {
                this.state.step = +hash[1];
            }
            if (hash[0] === 'prepurchaseId') {
                this.state.prepurchaseId = hash[1];
            }
            if (hash[0] === 'isHipaa') {
                this.state.isHipaa = hash[1];
            }
            if (hash[0] === 'features') {
                let f = (hash[1]).split('%2C');
                f.forEach((m) => {
                    if (!!m) {
                        this.state.selectedFeatures[+m] = true;
                    }
                });
            }
        }

        if(!this.state.prepurchaseId) {
            this.state.prepurchaseId = localStorage.getItem(appConfig.prepurchaseIdKey); 
            const params = { plan: this.state.plan, step: this.state.step, prepurchaseId: this.state.prepurchaseId };
            this.saveHistoryState(params);
        }

        if(!this.state.prepurchaseId) {
            this.state.prepurchaseId = uuidv4();
            localStorage.setItem(appConfig.prepurchaseIdKey, this.state.prepurchaseId);
            const params = { plan: this.state.plan, step: this.state.step, prepurchaseId: this.state.prepurchaseId };
            this.saveHistoryState(params);
        } else {
           try {
                const accountInfoStr = localStorage.getItem(appConfig.prepurchaseAccountInfoId); //, JSON.stringify(data));
                if(accountInfoStr) {
                    this.state.accountInfo = JSON.parse(accountInfoStr);
                    this.state.step1filled = this.state.refresh.accountFormRefresh(this.state.accountInfo);
                    if(!this.state.step1filled) {
                        this.state.step = 0;
                    }
                    
                } else {
                    this.state.step = 0;
                }
            } catch {    
                this.state.step = 0;
            }
        }

        this.state.planDescription = this.planService.getPlan(this.state.plan);
        this.state.features = [];
        this.state.activeFeatures = [];
        for (let i = 0; i < this.state.planDescription.optionalFeatures.length; i++) {
            let feature = Object.assign({}, this.state.planDescription.optionalFeatures[i]);
            if (this.state.selectedFeatures[feature.id]) {
                feature.isChecked = true;
                this.state.activeFeatures.push(feature);
            }
            this.state.features.push(feature);
        }
        this.forceUpdate();
    }

    addFeatures = () => {
        this.state.activeFeatures = [];
        this.state.features.forEach((f) => {
            if (f.isChecked) {
                this.state.activeFeatures.push(f);
            }
        });
        const params = { plan: this.state.plan, step: this.state.step, features: this.getFeatures(), prepurchaseId: this.state.prepurchaseId, isHipaa: this.state.isHipaa };
        this.saveHistoryState(params);
    }

    skipFeatures = () => {
        this.state.features.forEach((f) => {
            f.isChecked = false;
        });
        this.state.activeFeatures = [];
        const params = { plan: this.state.plan, step: this.state.step, prepurchaseId: this.state.prepurchaseId, isHipaa: this.state.isHipaa };
        this.saveHistoryState(params);
    }

    saveHistoryState(params) {
        const queryString = Object.keys(params).map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
        }).join('&');
        window.history.pushState(null, null, `${this.url}?${queryString}`);
    }
    toggleFeature(feature) {
        feature.isChecked = !feature.isChecked;
        this.forceUpdate();
    }
    getFeaturesArray() {
        let res = [];
        this.state.features.forEach((f) => {
            if (f.isChecked) {
                res.push(f.id);
            }
        });
        return res;
    }
    
    onConfetti() {
        this.scrollTop();
        /*
        const topSection = document.getElementById('purchase-top-section');
        if(topSection) {
            topSection.classList.add('txr-display-none');
        }*/
        const canvas = document.getElementById('purchased-canvas');
        canvas.confetti = canvas.confetti || confetti.create(canvas, {
            resize: true
        });

        var end = Date.now() + (3 * 1000);
        (function frame() {
            const colors = ['#9FCC47', '#BDDE7C', '#DFEFC1'];
            const colorIndex =  Math.floor(Math.random() * Math.floor(colors.length - 1));
            canvas.confetti({
                particleCount: 1,
                startVelocity: 0,
                ticks: 200,
                origin: {
                    x: Math.random(),
                    // since they fall down, start a bit higher than random
                    y: Math.random() - 0.2
                },
                colors: [colors[colorIndex]],
                shapes: ['square']
            });
            if (Date.now() < end) {
                requestAnimationFrame(frame);
            } //, 
        }());
    }

    render() {
        return (
            <div class="txr-purchase-workflow">
            {
               !this.state.isPurchased && 
                <div class="txr-purchase-workflow-process">
                    <div class="purchase-header">
                        <h2 class={classNames({ 'purchase-header__item': true, 'purchase-header__item-selected': this.state.step === 0, 'purchase-header__item-clickable': true })} onClick={() => this.setStep(0)}>
                            <span class="header-item__num">1</span>
                            <span class="header-item__text">. Account Information</span>
                        </h2>
                        <h2 class={classNames({ 'purchase-header__item': true, 'purchase-header__item-selected': this.state.step === 1 || this.state.step === 11, 'purchase-header__item-clickable': this.state.step1filled })} onClick={() => this.setStep(1)}>
                            <span class="header-item__num">2</span>
                            <span class="header-item__text">. Add-on Features</span>
                        </h2>
                        <h2 class={classNames({ 'purchase-header__item': true, 'purchase-header__item-selected': this.state.step === 2, 'purchase-header__item-clickable': this.state.step2filled })} onClick={() => this.setStep(2)}>
                            <span class="header-item__num">3</span>
                            <span class="header-item__text">. Payment Details</span>
                        </h2>
                    </div>
                    <div class="purchase-content">
                        <div class={classNames({ 'purchase-content__item': true, 'purchase-header__item-selected': this.state.step === 0 })}>
                            <h2 class="purchase-content__item-title">Add account information</h2>
                            <TxrPurchaseAccountForm prepurchaseId={this.state.prepurchaseId} plan={this.state.plan} refresh={this.state.refresh} onContinue={(accountInfo) => this.completeStep1(accountInfo)}></TxrPurchaseAccountForm>
                        </div>
                        <div class={classNames({ 'purchase-content__item': true, 'purchase-header__item-selected': this.state.step === 1 || this.state.step === 11 })}>
                            <div class="txr-purchase-plan-selection">
                                <div class="plan-selection__left">
                                    <h2 class="plan-selection__header">Your plan selection</h2>
                                    <div class="plan-selection__panel">
                                        { this.state.planDescription.discountPrice && 
                                        <div class="plan-desc__banner">
                                            FINAL PRICING SHOWN AT CHECKOUT
                                        </div>
                                        }
                                        <div class="plan-desc__header">
                                            <div class="header__title">{this.state.planDescription.name} <br/>Plan</div>
                                            <div class="header__price">${formatNumber(this.state.planDescription.price)}<span class="header__price-hint">/ mo</span></div>
                                        </div>
                                        <div class="plan-desc__content">
                                            <div class="content__left">
                                                <div class="content-value">{this.state.planDescription.includedTexts}</div>
                                                <div class="content-hint">Included texts</div>
                                                <div class="content-value">{this.state.planDescription.dashboards}</div>
                                                <div class="content-hint">Dashboard{this.state.planDescription.dashboards == 1 ? '' : 's'}</div>
                                                <div class="content-value">{this.state.planDescription.addTexts}</div>
                                                <div class="content-hint">Additional texts</div>
                                            </div>
                                            <div class="content__right">
                                                <div class="features-title">Included features:</div>
                                                {this.state.planDescription.includedFeatures.map(feature =>
                                                    <div class="features-item">
                                                        <i class="features-item__icon fas fa-check"></i>
                                                        <span class="features-item__text">{feature}</span>
                                                    </div>
                                                )
                                                }
                                                {
                                                    this.state.planDescription.isHighVolume &&
                                                    <div class="features-item">
                                                        <i class="features-item__icon fas fa-check"></i>
                                                        <span class="features-item__text">$5 Additional Dashboards</span>
                                                    </div>
                                                }
                                                {
                                                    this.state.planDescription.isHighVolume &&
                                                    <div class="features-item">
                                                        <i class="features-item__icon fas fa-check"></i>
                                                        <span class="features-item__text">All Enterprise Features</span>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div class="plan-selection__link">
                                        <a class="txr-angle__link txr-mr25" href="/pricing">I’d like a different plan  <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                    </div>
                                </div>
                                {
                                this.state.step === 1 &&
                                <div class="plan-selection__right">
                                    <h2 class="plan-selection__header txr-mb20">HIPAA Compliance</h2>
                                            <div class={classNames({ 'plan-selection__feature': true, 'plan-selection__feature-selected': !this.state.isHipaa })} onClick={() => this.disableHipaa()}>
                                                <div class="plan-selection__feature-inner">
                                                    <div class="feature-left">
                                                        <h4 class="feature-header">Standard</h4>
                                                        <div class="feature-description">Security and compliance is guaranteed for all plans with end to end encryption.</div>
                                                    </div>
                                                    <div class="feature-right-nocost">
                                                        <span class="feature-cost">No additional charge</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class={classNames({ 'plan-selection__feature': true, 'plan-selection__feature-selected': this.state.isHipaa })} onClick={() => this.enableHipaa()}>
                                                <div class="plan-selection__feature-inner">
                                                    <div class="feature-left">
                                                        <h4 class="feature-header">HIPAA Compliant Texting</h4>
                                                        <div class="feature-description">Secure SMS and MMS messaging for healthcare professionals sending protected health information.</div>
                                                    </div>
                                                    <div class="feature-right">
                                                        <span class="feature-cost">${this.state.hipaa.cost}</span><span class="feature-cost__hint"> / mo</span>
                                                    </div>
                                                </div>
                                            </div>                                            
                                    <div class="plan-selection__buttons">
                                        <button class="txr-button txr-primary-button" type="button" onClick={() => this.completeStep1Go11(false)}>
                                            <span class="txr-button__content">
                                                CONTINUE <i class="txr-button__angle-icon fal fa-angle-right"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div> 
                                }                               
                                {
                                this.state.step === 11 &&
                                <div class="plan-selection__right">
                                    <h2 class="plan-selection__header txr-mb20">HIPAA Compliance</h2>
                                    { !this.state.isHipaa &&
                                     <div class="plan-selection__feature plan-selection__feature-selected">
                                                <div class="plan-selection__feature-inner">
                                                    <div class="feature-left">
                                                        <h4 class="feature-header">Standard</h4>
                                                        <div class="feature-description">Security and compliance is guaranteed for all plans with end to end encryption.</div>
                                                    </div>
                                                    <div class="feature-right-nocost">
                                                        <span class="feature-cost">No additional charge</span>
                                                    </div>
                                                </div>
                                      </div>
                                    }
                                    {this.state.isHipaa &&
                                      <div class="plan-selection__feature plan-selection__feature-selected">
                                                <div class="plan-selection__feature-inner">
                                                    <div class="feature-left">
                                                        <h4 class="feature-header">HIPAA Compliant Texting</h4>
                                                        <div class="feature-description">Secure SMS and MMS messaging for healthcare professionals sending protected health information.</div>
                                                    </div>
                                                    <div class="feature-right">
                                                        <span class="feature-cost">${this.state.hipaa.cost}</span><span class="feature-cost__hint"> / mo</span>
                                                    </div>
                                                </div>
                                    </div>      
                                    }
                                    <div class="txr-align-end txr-mb20">
                                        <a class="txr-angle__link txr-mr25" onClick={() => this.completeStep1(true)}>Change this setting  <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                    </div>
                                    <h2 class="plan-selection__header">Select additional features</h2>
                                    <div class="plan-selection__hint">Click to add any of the following features:</div>
                                    {
                                        this.state.features.map(feature =>
                                            <div class={classNames({ 'plan-selection__feature': true, 'plan-selection__feature-selected': feature.isChecked })} onClick={() => this.toggleFeature(feature)}>
                                                <div class="plan-selection__feature-inner">
                                                    <div class="feature-left">
                                                        <h4 class="feature-header">{feature.name}</h4>
                                                        <div class="feature-description">{feature.description}</div>
                                                    </div>
                                                    <div class="feature-right">
                                                        <span class="feature-cost">${feature.cost}</span><span class="feature-cost__hint"> / mo</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    <div class="plan-selection__buttons">
                                        <button class="txr-button txr-primary-button" type="button" onClick={() => this.completeStep2(false)}>
                                            <span class="txr-button__content">
                                                CONTINUE <i class="txr-button__angle-icon fal fa-angle-right"></i>
                                            </span>
                                        </button>
                                        <a class="txr-angle__link" onClick={() => this.completeStep2(true)}>Skip for now  <i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                        <div class={classNames({ 'purchase-content__item': true, 'purchase-header__item-selected': this.state.step === 2 })}>
                            <TxrPurchaseForm plan={this.state.planDescription} 
                            prepurchaseId={this.state.prepurchaseId} 
                            features={this.state.activeFeatures} 
                            isHipaa={this.state.isHipaa}
                            accountInfo={this.state.accountInfo} onPurchase={(tokenData) => this.completeStep3(tokenData)}></TxrPurchaseForm>
                    </div>
                    </div>
                </div>
            }
           
               <div class={classNames({ 'txr-purchase-workflow-success': true, 'txr-purchase-workflow-success__active': this.state.isPurchased })}>
                     <canvas id="purchased-canvas" class="purchased-canvas"></canvas>
                     <div class="sucess-container">
                        <div class="purchase-success__left">
                            <h3 class="sucess-text">Your plan selection</h3>
                            <div class="sucess-title"  onClick={() => this.onConfetti()}>The {this.state.planDescription.name} Plan</div>
                            <h3 class="sucess-text">is complete!</h3>
                            <div class="sucess-hint">Welcome to the Text Request family. Now, let’s get you on your way to sending your first text!</div>
                            <div class="sucess-hint">To ensure the security of your account, please log in using your account credentials.</div>
                            <button class="txr-button txr-primary-button " type="button" onClick={() => this.goToSmsHosting()}>
                                    <span class="txr-button__content"> PROCEED TO LOGIN
                                        <i class="txr-button__angle-icon fal fa-angle-right"></i>
                                    </span>
                            </button>
                        </div>
                        <div class="purchase-success__right">
                            <img src="/images/pricing/frank_celebrate2a.svg"></img>
                        </div>
                     </div>
               </div>
           
            </div>
        )
    }
}
export default TxrPurchaseWorkflow;